import React from "react";
import { Container, Row, Col } from "reactstrap";

export default function AdminFooter() {
  return (
    <>
      <Container fluid>
        <footer className="footer pt-0">
          <Row className="align-items-center justify-content-lg-between">
            <Col lg="6">
              <div className="copyright text-center text-lg-left text-muted">
                © {new Date().getFullYear()}{" "}
                <a
                  className="font-weight-bold ml-1"
                  href="http://grsmotorgroup.co.uk/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GRS Motor Group
                </a>
              </div>
            </Col>
            <Col lg="6">
            </Col>
          </Row>
        </footer>
      </Container>
    </>
  );
}